/** Lazy-load Video.js (and its CSS) only when ARVideo initializes. */
let loadPromise: Promise<any> | undefined;

export async function loadVideoJs(): Promise<any> {
  if (!loadPromise) {
    loadPromise = import('video.js/dist/video-js.css').then(() =>
      import('video.js').then((mod) => mod.default ?? mod)
    );
  }
  return loadPromise;
}
